export function DemoDataBadge({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-medium text-amber-900 ${className}`}>
      <span className="size-1.5 rounded-full bg-amber-500" />
      Demo data
    </span>
  )
}
